<a class="c-blue-1" *ngIf="(meterToDisplay | async) as meter; else noData" routerLink="/meters/meter/{{meter.id}}"  [queryParams]="{fid: fleetId}" style="cursor: pointer">{{meter.name}}</a>
<ng-template #noData></ng-template>
